import React from 'react';

import useYoungPersonCategories from '../Queries/useYoungPersonCategories';
import ProCategories, {RESOURCE_TITLE_CLASSES, ResourceBreadcrumbs} from './ProCategories';
import {YOUNG_PERSON_CATEGORY_ICONS} from '../Util/constants';

const ProYoungPersonCategories = () => {
  const {data: categories, error, refetch} = useYoungPersonCategories();
  const categoriesWithIcons = categories?.map((category) => ({
    ...category,
    icon: YOUNG_PERSON_CATEGORY_ICONS[category.key],
  }));

  return (
    <div data-testid="pro-young-person-categories">
      <ResourceBreadcrumbs items={[{label: 'Home', to: '/dashboard'}, {label: 'Young People'}]} />
      <h1 className={`mb-6 ${RESOURCE_TITLE_CLASSES}`}>Young People</h1>
      <ProCategories
        categories={categoriesWithIcons}
        error={error}
        refetch={refetch}
        resourceLabel="young person resources"
      />
    </div>
  );
};

export default ProYoungPersonCategories;
